import { render, staticRenderFns } from "./BusinessSettingView.vue?vue&type=template&id=57534694&scoped=true&"
import script from "./BusinessSettingView.vue?vue&type=script&lang=js&"
export * from "./BusinessSettingView.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSettingView.vue?vue&type=style&index=0&id=57534694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57534694",
  null
  
)

export default component.exports